var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("breadcrumb-top", { attrs: { breadcrumbConfig: _vm.dataList } }),
      _c("div", { staticClass: "content" }, [
        _c("h2", [_vm._v("抖店资源")]),
        _c("h3", [_vm._v("数据筛选")]),
        _c(
          "div",
          [
            _c(
              "el-form",
              {
                ref: "searchForm",
                attrs: {
                  inline: true,
                  model: _vm.searchForm,
                  size: "small",
                  "label-width": "90px",
                },
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "订单编号", prop: "orderId" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入订单编号", clearable: "" },
                      model: {
                        value: _vm.searchForm.orderId,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "orderId", $$v)
                        },
                        expression: "searchForm.orderId",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "商品名称", prop: "goodsName" } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "215px" },
                      attrs: { placeholder: "请输入商品名称" },
                      model: {
                        value: _vm.searchForm.goodsName,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "goodsName", $$v)
                        },
                        expression: "searchForm.goodsName",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "收货人信息", prop: "postUserInfo" } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "215px" },
                      attrs: { placeholder: "请输入收货人信息" },
                      model: {
                        value: _vm.searchForm.postUserInfo,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "postUserInfo", $$v)
                        },
                        expression: "searchForm.postUserInfo",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "下单时间", prop: "brandId" } },
                  [
                    _c("el-date-picker", {
                      staticStyle: { width: "215px" },
                      attrs: {
                        type: "daterange",
                        "range-separator": "至",
                        "start-placeholder": "开始日期",
                        "end-placeholder": "结束日期",
                        "default-time": ["00:00:00", "23:59:59"],
                        "value-format": "yyyy-MM-dd HH:mm:ss",
                      },
                      model: {
                        value: _vm.createTime,
                        callback: function ($$v) {
                          _vm.createTime = $$v
                        },
                        expression: "createTime",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "订单状态", prop: "orderStatus" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          placeholder: "请选择订单状态",
                          filterable: "",
                          clearable: "",
                        },
                        model: {
                          value: _vm.searchForm.orderStatus,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "orderStatus", $$v)
                          },
                          expression: "searchForm.orderStatus",
                        },
                      },
                      _vm._l(
                        _vm.dictionaries.dou_order_status,
                        function (item) {
                          return _c("el-option", {
                            key: item.dictId,
                            attrs: { label: item.dictName, value: item.dictId },
                          })
                        }
                      ),
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "导出状态", prop: "exportStatus" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          placeholder: "请选择导出状态",
                          filterable: "",
                          clearable: "",
                        },
                        model: {
                          value: _vm.searchForm.exportStatus,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "exportStatus", $$v)
                          },
                          expression: "searchForm.exportStatus",
                        },
                      },
                      _vm._l(_vm.exportStatuss, function (item) {
                        return _c("el-option", {
                          key: item.dictId,
                          attrs: { label: item.dictName, value: item.dictId },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "解密时间", prop: "decryptTime" } },
                  [
                    _c("el-date-picker", {
                      staticStyle: { width: "215px" },
                      attrs: {
                        type: "daterange",
                        "range-separator": "至",
                        "start-placeholder": "开始日期",
                        "end-placeholder": "结束日期",
                        "default-time": ["00:00:00", "23:59:59"],
                        "value-format": "yyyy-MM-dd HH:mm:ss",
                      },
                      model: {
                        value: _vm.decryptTime,
                        callback: function ($$v) {
                          _vm.decryptTime = $$v
                        },
                        expression: "decryptTime",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "导出时间", prop: "exportTime" } },
                  [
                    _c("el-date-picker", {
                      staticStyle: { width: "215px" },
                      attrs: {
                        type: "daterange",
                        "range-separator": "至",
                        "start-placeholder": "开始日期",
                        "end-placeholder": "结束日期",
                        "default-time": ["00:00:00", "23:59:59"],
                        "value-format": "yyyy-MM-dd HH:mm:ss",
                      },
                      model: {
                        value: _vm.exportTime,
                        callback: function ($$v) {
                          _vm.exportTime = $$v
                        },
                        expression: "exportTime",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "店铺来源", prop: "shopId" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: {
                          placeholder: "请选择店铺来源",
                          filterable: "",
                          clearable: "",
                        },
                        model: {
                          value: _vm.searchForm.shopId,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "shopId", $$v)
                          },
                          expression: "searchForm.shopId",
                        },
                      },
                      _vm._l(_vm.dictionaries.dou_shop_id, function (item) {
                        return _c("el-option", {
                          key: item.dictId,
                          attrs: { label: item.dictName, value: item.dictId },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _c("el-form-item", { attrs: { label: "" } }, [
                  _c(
                    "div",
                    { staticStyle: { display: "flex", "margin-top": "4px" } },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "btn-search",
                          on: {
                            click: function ($event) {
                              return _vm.fetchData("search")
                            },
                          },
                        },
                        [_vm._v("查询")]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "btn-search",
                          staticStyle: { "margin-left": "20px" },
                          on: {
                            click: function ($event) {
                              return _vm.fetchData("reset")
                            },
                          },
                        },
                        [_vm._v(" 重置 ")]
                      ),
                    ]
                  ),
                ]),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("div", { staticClass: "title" }, [
            _c("h3", [_vm._v("列表数据")]),
            _c("div", { staticStyle: { display: "flex" } }, [
              _c(
                "div",
                {
                  staticClass: "derive",
                  staticStyle: { "margin-right": "10px" },
                  on: { click: _vm.deriveDeliver },
                },
                [_vm._v("导出")]
              ),
              _c(
                "div",
                {
                  staticClass: "derive",
                  on: { click: _vm.deriveDeliverRecord },
                },
                [_vm._v("导出记录")]
              ),
            ]),
          ]),
          _c("orders-list-table", {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            attrs: {
              dataList: _vm.page.list,
              heightStr: _vm.columns.height,
              config: _vm.columns.config,
              typeStr: _vm.columns.type,
            },
            on: {
              optionDialog: _vm.optionDialog,
              lookDialog: _vm.lookDialog,
              tableSelectionChange: _vm.tableSelectionChange,
            },
          }),
          _c(
            "div",
            {
              staticClass: "page",
              staticStyle: {
                float: "right",
                margin: "10px 10px",
                "padding-bottom": "10px",
              },
            },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  "current-page": _vm.page.currentPage,
                  "page-sizes": [3, 5, 10, 20, 50],
                  "page-size": _vm.page.pageSize,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.page.totalNum,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                  "update:currentPage": function ($event) {
                    return _vm.$set(_vm.page, "currentPage", $event)
                  },
                  "update:current-page": function ($event) {
                    return _vm.$set(_vm.page, "currentPage", $event)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "导出记录",
            visible: _vm.dialogRecord,
            "append-to-body": "",
            width: "40%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogRecord = $event
            },
          },
        },
        [
          _c("lb-table", {
            attrs: {
              column: _vm.columnsDeriveRecord,
              data: _vm.deriveRecordList.list,
              pagination: "",
              total: _vm.deriveRecordList.totalNum,
              layout: "total, sizes, prev, pager, next, jumper",
              "page-sizes": [5, 10, 20, 30, 50],
              "current-page": _vm.pageNo,
              "page-size": _vm.pageSize,
            },
            on: {
              "update:currentPage": function ($event) {
                _vm.pageNo = $event
              },
              "update:current-page": function ($event) {
                _vm.pageNo = $event
              },
              "size-change": _vm.handleSizeChangeDeriveRecord,
              "p-current-change": _vm.handleCurrentChangeDeriveRecord,
            },
          }),
          _c(
            "div",
            { staticStyle: { "margin-top": "20px", "text-align": "center" } },
            [
              _c(
                "el-button",
                {
                  staticStyle: { "margin-right": "20px" },
                  attrs: { plain: "" },
                  on: {
                    click: function ($event) {
                      _vm.dialogRecord = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.dialogRecord = false
                    },
                  },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }